import React from 'react';
import PropTypes from 'prop-types';
import classes from './CustomFormInput.module.scss';

const CustomFormInput = (props) => {
    const { inputData, formik, isDisabled=false, inputClassName, maxLength, helperText='' } = props;
    if (!inputData?.is_active) return null;

    return (
        <div className={`${classes.CustomFormInput} ${inputClassName}`}>
            {inputData?.label ? 
                (<label htmlFor={inputData?.input_id}>
                    {inputData?.label}
                    {inputData?.is_required ? <span className='required'>*</span> : null}
                </label>) 
            : null}
            <input
                type={inputData?.input_type}
                name={inputData?.input_name}
                id={inputData?.input_id}
                placeholder={inputData?.placeholder}
                value={formik.values[inputData?.input_name] || ''}
                onChange={formik.handleChange}
                disabled={isDisabled}
                maxLength={maxLength}
            />
            {helperText ? 
                <span className='helper-text'><strong>{helperText}</strong></span>
            : <>
                {inputData?.helper_text ? (
                    <span className='helper-text'>{inputData?.helper_text}</span>
                ) : null}
            </>}
            {formik.touched[inputData?.input_name] && formik.errors[inputData?.input_name] ? (
                <span className="form-error">{formik.errors[inputData?.input_name]}</span>
            ) : null}
        </div>
    )
}

CustomFormInput.propTypes = {}

export default CustomFormInput;